<template>
  <div :style="new_style_variables" :class="getSlug()">
    <Header
      v-if="loadfinal"
      :logo_link="`/index.html`"
      :home_link="`/index.html`"
      :lang="lang.toUpperCase()"
      :show_home="true"
      :show_faqs="false"
      :show_manage="false"
      :show_languages="true"
      :show_basket="false"
      :show_login="false"
      :show_signup="false"
      :brandSlug="brand_slug"
      :basket_number="0"
      :logoutText="getrans('Logout')"
      @logo-loaded="onLogoLoaded"
    ></Header>
    <div class="page-bg" :class="brand_slug">
      <div class="top-panel">
        <div class="top-panel-inner">
          <h1 v-if="brand_slug === 'SV1'">{{ getrans("Manage Bookings") }}</h1>
          <h1 v-else>{{ getrans("Login") }}</h1>
        </div>
      </div>

      <div class="page-container">
        <div class="page-left">
          <div class="form-panel" style="text-align: left">
            <div class="form-inner" v-if="userexists">
              <div class="title-area">
                <h3>
                  {{
                    getrans(
                      "The email id entered does not exist in our system."
                    )
                  }}
                </h3>
              </div>
            </div>

            <div class="form-inner" v-if="loginistrue">
              <div class="title-area">
                <h3>{{ getrans("Please enter your email to continue") }}</h3>
              </div>

              <div class="form-inputs">
                <div
                  class="block-wrap block-wrap-has-question-icon"
                  style="width: 50%"
                >
                  <div
                    class="block"
                    :class="`${emailInvalid ? 'error' : ''} ${
                      emailValid ? 'tick' : ''
                    } ${emailid ? 'hasValue' : ''}`"
                  >
                    <input
                      name="emailid"
                      autofocus="autofocus"
                      type="text"
                      id="emailid"
                      v-model.trim="emailid"
                      data-lpignore="true"
                      @keyup.enter="proceedtocheckuser"
                      :disabled="!logoLoaded"
                    />
                    <label for="emailid">
                      <template v-if="brand_slug === 'SV1'">
                        {{ getrans("Email address") }}
                      </template>
                      <template v-else>
                        {{ getrans("Enter your email address") }}
                      </template>
                      <span class="form-mandatory">*</span>
                    </label>
                  </div>
                </div>

                <div class="block-wrap" style="width: 100%">
                  <div class="block-wrap-btn">
                    <button
                      type="button"
                      @mousedown="proceedtocheckuser"
                      @keyup.enter="proceedtocheckuser"
                      :disabled="submitStatusCheckEmail === 'PENDING' || !logoLoaded"
                      class="proceed-btn"
                    >
                      <i
                        v-if="submitStatusCheckEmail === 'PENDING'"
                        class="fas fa-circle-notch fa-spin"
                      ></i>
                      {{ getrans("Proceed") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-inner" v-if="passistrue">
              <div class="title-area" v-if="display_msg">
                <h3 class="page-content__form-title">
                  {{ getrans(display_msg) }}
                </h3>
              </div>
              <div v-else class="title-area">
                <h3 v-if="brand_slug === 'NWI'">
                  {{
                    getrans(
                      "You have been sent a 6 digit One Time Passcode to"
                    )
                  }}&nbsp;{{ emailid }}
                </h3>
                <h3 v-else-if="brand_slug === 'YHM'">
                  {{
                    getrans(
                      "You have been sent a one-time passcode (OTP) to your registered email."
                    )
                  }}
                </h3>
                <h3 v-else-if="brand_slug === 'SV1'">
                  {{ getrans("We have sent a one-time passcode to") }}&nbsp;{{
                    emailid
                  }}
                </h3>
                <h3 v-else>
                  {{
                    getrans(
                      "You have been sent a 6 digit One Time Passcode to"
                    )
                  }}&nbsp;{{ emailid }}
                </h3>
              </div>

              <div class="form-inputs" style="padding: 0.5rem">
                <div class="block-wrap" style="width: 60%">
                  <OTPInput
                    message=""
                    v-on:opt_change="opt_change"
                    :otpLength="6"
                  />
                  <RememberDeviceComponent
                    v-if="brand_slug == 'LAX'"
                    v-model="rememberDevice"
                  />

                  <p>
                    <template v-if="brand_slug === 'SV1'">
                      Please leave this tab open while retrieving the access
                      code.
                    </template>
                    <template v-else>
                      {{
                        getrans(
                          "Please do not access your email in this tab, please leave this tab open as you check your email to retrieve the One Time Passcode."
                        )
                      }}
                    </template>
                  </p>
                  <p>
                    {{ getrans("Didn't receive code?") }}&nbsp;<a href="/">{{
                      getrans("try again")
                    }}</a>
                  </p>
                  
                  <div v-if="showEmailFallback && display_msg && brand_slug === 'LAX'" class="email-fallback-section">
                    <p style="color: #666; margin-top: 15px;">
                      {{ getrans("Can't access SMS?") }}
                      <a
                        href="#"
                        @click.prevent="sendEmailFallback"
                        :class="{ 'disabled-link': emailFallbackTimer > 0 }"
                        style="margin-left: 5px; color: #0066cc; text-decoration: underline;"
                      >
                        <i v-if="submitSendcodeoption_email" class="fas fa-circle-notch fa-spin"></i>
                        {{ emailFallbackTimer > 0 ? `${getrans('Send via Email')} (${emailFallbackTimer}s)` : getrans('Send via Email') }}
                      </a>
                    </p>
                  </div>

                  <div
                    style="display: none"
                    class="block"
                    :class="`${passwordWrong ? 'error' : ''} ${
                      passwordCorrect ? 'tick' : ''
                    } ${password ? 'hasValue' : ''}`"
                  >
                    <input
                      name="otpotp"
                      autofocus="false"
                      type="password"
                      v-model.trim="password"
                      data-lpignore="true"
                      @keyup.enter="proceedtologinuser"
                      @input="ValidatePassword"
                    />
                    <label for="password" v-if="brand_slug === 'YHM'">
                      {{
                        getrans(
                          "Please enter your OTP below to access your account"
                        )
                      }}
                      <span class="form-mandatory">*</span>
                    </label>
                    <label for="password" v-else>
                      {{ getrans("Enter your OTP") }}
                      <span class="form-mandatory">*</span>
                    </label>
                  </div>
                </div>
                <div class="block-wrap-btns">
                  <button
                    type="button"
                    @mousedown="proceedtologinuser"
                    @keyup.enter="proceedtologinuser"
                    :disabled="
                      !password || submitStatusCheckPassword === 'PENDING'
                    "
                    class="proceed-btn login-btn"
                  >
                    <i
                      v-if="submitStatusCheckPassword === 'PENDING'"
                      class="fas fa-circle-notch fa-spin"
                    ></i
                    >&nbsp;
                    <template v-if="brand_slug === 'SV1'">
                      {{ getrans("Log In") }}
                    </template>
                    <template v-else>
                      {{ getrans("Login") }}
                    </template>
                  </button>

                  <button
                    type="button"
                    @click="cancellogin"
                    class="proceed-btn cancel-btn"
                  >
                    {{ getrans("Cancel") }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="form-inner"
              v-if="callemailsms && !passistrue && !loginistrue"
            >
              <div class="form-inputs">
                <div class="title-area">
                  <h3>
                    {{
                      getrans(
                        "How do you like to receive the 6 digit One Time Passcode to proceed?"
                      )
                    }}
                  </h3>
                </div>

                <div class="block-wrap-btns" style="width: 100%">
                  <button
                    type="button"
                    @click="sendcodeoption('email')"
                    class="proceed-btn login-btn"
                  >
                    <i
                      v-if="submitSendcodeoption_email"
                      class="fas fa-circle-notch fa-spin"
                    ></i>
                    {{ getrans("Email") }}
                  </button>
                  <button
                    type="button"
                    @click="sendcodeoption('sms')"
                    class="proceed-btn sms-btn"
                    style="margin-left: 1rem"
                  >
                    <i
                      v-if="submitSendcodeoption_sms"
                      class="fas fa-circle-notch fa-spin"
                    ></i>
                    {{ getrans("SMS") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="page-right"></div>
        </div>
      </div>
    </div>
    <Footer
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brand_slug"
    ></Footer>
    <Cookies :brandSlug="brand_slug" />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import Cookies from "../../components/Cookies.vue";
import OTPInput from "../../components/OTPInput.vue";
import RememberDeviceComponent from "../../components/RememberDeviceComponent.vue";
import RememberDevice from "../../modules/RememberDevice";
import SessionManager from "../../modules/SessionManager";
import SessionValidator from "../../modules/SessionValidator";  
import axios from "axios";
import Swal from "sweetalert2";
import md5 from "js-md5";
import apiProxy from "../../services/apiProxy";
import securityService from "../../services/securityService";
import sessionService from "../../services/sessionService";
const localforage = require("localforage");
import { mapActions, mapGetters } from "vuex";
let store = localforage.createInstance({
  name: "tranlations",
});
import("primevue/resources/themes/saga-blue/theme.css");
import("primevue/resources/primevue.min.css");
import("primeicons/primeicons.css");
import { set_style_vars } from "@/modules/set_style_vars";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Cookies,
    OTPInput,
    RememberDeviceComponent,
  },
  data() {
    return {
      brand_slug: "",
      translations: "",
      lang: "",
      branding_data: {},
      emailid: "",
      emailInvalid: false,
      callemailsms: false,
      loadfinal: false,
      passwordless: false,
      emailValid: false,
      password: "",
      passwordWrong: false,
      passwordCorrect: false,
      userexists: false,
      loginistrue: true,
      passistrue: false,
      display_msg: "",
      submitStatusCheckEmail: "OK",
      submitStatusCheckPassword: "OK",
      domain: null,
      brand_product_styles: {},
      header_menu: [],
      footer_links: [],
      footer_columns: "1 Row",
      submitSendcodeoption_email: false,
      submitSendcodeoption_sms: false,
      rememberDeviceComp: false,
      rememberDevice: false,
      emailFallbackTimer: 0,
      showEmailFallback: false,
      logoLoaded: false,

    };
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles);
    },
    set_style_variables: function () {
      return {
        "--brand_color_1": this.brand_color_1 || "#ffffff",
        "--brand_color_2": this.brand_color_2 || "#1a2a40",
        "--brand_color_3": this.brand_color_3 || "#dea602",
        "--tab_active_text_color": this.tab_active_text_color || "#1a2a40",
        "--tab_active_text_size": this.tab_active_text_size || "#1a2a40",
        "--tab_in_active_text_color": this.tab_inactive_text_color || "1rem",
        "--tab_in_active_text_size": this.tab_inactive_text_size || "1rem",
        "--border_radius": this.border_radius || "0",
      };
    },
  },
  methods: {
    ...mapActions(["setSlug", "setBranding"]),
    ...mapGetters(["getSlug", "getCurrency", "getBranding"]),
    setStyles(obj) {
      /* eslint-disable */
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      /* eslint-enable */
    },
    async sendEmailOTP(emailEntered) {
      try {
        const response = await apiProxy.call('sso_email_otp_send', {
          brand_id: this.brand_slug,
          email_id: emailEntered,
          language: this.lang.toUpperCase(),
        });
        
        this.loginistrue = false;
        this.passistrue = true;
        this.password = "";
        this.userexists = false;
        this.submitStatusCheckEmail = "OK";
        this.passwordWrong = false;
        this.passwordCorrect = true;
      } catch (error) {
        console.error('Email OTP send failed:', error);
        this.showError('Failed to send email OTP. Please try again.');
      }
    },
    async sendcodeoption(val) {
      if (val == "email") {
        this.submitSendcodeoption_email = true;
        await this.sendEmailOTP(this.emailid);
        this.submitSendcodeoption_email = false;
        this.callemailsms = false;
      }
      if (val == "sms") {
        this.submitSendcodeoption_sms = true;
        try {
          const response = await apiProxy.call('sso_mobile_otp_send', {
            brand_id: this.brand_slug,
            email_id: this.emailid,
          });
          
          this.submitSendcodeoption_sms = false;
          this.loginistrue = false;
          this.passistrue = true;
          this.callemailsms = false;
          this.password = "";
          
          if (response && response.msg && response.msg.display_msg) {
            this.display_msg = response.msg.display_msg;
            if (this.brand_slug === 'LAX') {
              this.startEmailFallbackTimer();
            }
          }
        } catch (error) {
          console.error('SMS OTP send failed:', error);
          this.submitSendcodeoption_sms = false;
          this.showError('Failed to send SMS OTP. Please try again.');
        }
      }
    },
    setMenu(data) {
      data.brand_menu_mmb.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });
      const top_menu = data.brand_menu_mmb.filter(
        (menu) => menu.position === "T"
      );
      this.createHeaderLinks(top_menu);
      const footer_menu = data.brand_menu_mmb.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (menu.label.toLowerCase() !== "home") {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    opt_change(value) {
      this.password = value;
    },
    validatePassword() {
      this.passwordWrong = this.password.length !== 6 || isNaN(this.password);
      this.passwordCorrect =
        this.password.length > 0 &&
        this.password.length === 6 &&
        !isNaN(this.password);
    },
    validateEmail(mail) {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        return true;
      }
      return false;
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.brand_slug + "-" + this.lang.toUpperCase() + "-" + s;
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    async loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        vm.setSessionData("language", vm.lang);
      }

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      try {
        const params = await store.getItem("tranlations");
        if (params !== null) {
          vm.translations = JSON.parse(params);
          this.loadfinal = true;
        } else {
          const response = await apiProxy.callPreAuth('translation_api', {
            brandslug: vm.brand_slug
          });
          vm.translations = response;
          await store.setItem("tranlations", JSON.stringify(vm.translations));
          this.loadfinal = true;
        }
      } catch (error) {
        console.error('Translation loading failed:', error);
        this.loadfinal = true;
      }
    },
    async proceedtocheckuser() {
      if (!this.validateEmail(this.emailid)) {
        this.submitStatusCheckEmail = "ERROR";
        this.emailInvalid = true;
        this.emailValid = false;
        this.showError("Please enter email id to continue");
        return;
      }

      let emailEntered = this.emailid;
      this.submitStatusCheckEmail = "PENDING";
      this.emailInvalid = false;
      this.emailValid = true;

      try {
        const response = await apiProxy.call('sso_email_verify', {
          brand_id: this.brand_slug,
          email_id: emailEntered
        });

        console.log('SSO Email Verify Response:', JSON.stringify(response, null, 2));
        console.log('Response code:', response.code, 'Type:', typeof response.code);
        console.log('Response msg:', response.msg);

        if (response.code === 1 && response.msg) {
          // User exists and can proceed with OTP
          if (response.msg.login_type === "passwordless") {
            this.passwordless = true;
            let send_email = response.msg.send_email?.toString();
            let send_sms = response.msg.send_sms?.toString();
            
            // For LAX brand, check OTP preference first
            if (this.brand_slug === "LAX") {
              try {
                const otpPrefResponse = await apiProxy.call('otp_preference_view', {
                  email_id: emailEntered,
                  brand_id: this.brand_slug,
                });
                
                const otpPreference = otpPrefResponse.code === 1
                  ? otpPrefResponse.data.otp_preference
                  : "email";

                if (otpPreference === "sms") {
                  this.sendcodeoption('sms');
                } else {
                  this.sendEmailOTP(emailEntered);
                }
              } catch (error) {
                this.sendEmailOTP(emailEntered);
              }
              return;
            }
            
            if (this.brand_slug == "NWI") {
              if (send_email == "true" && send_sms == "false") {
                this.sendEmailOTP(emailEntered);
              } else if (send_sms == "true" && send_email == "false") {
                this.sendEmailOTP(emailEntered);
              } else if (send_sms == "true" && send_email == "true") {
                this.userexists = false;
                this.submitStatusCheckEmail = "OK";
                this.passwordWrong = false;
                this.passwordCorrect = true;
                this.loginistrue = false;
                this.callemailsms = true;
              }
            } else {
              this.sendEmailOTP(emailEntered);
            }
          }
        } else if (response.code === 37) {
          // User does not exist
          this.loginistrue = true;
          this.passistrue = false;
          this.password = "";
          this.userexists = false;
          this.submitStatusCheckEmail = "OK";

          if (response.data?.msg) {
            this.showError(this.getrans(response.data.msg));
          } else {
            this.showError("This account does not exist. Please contact Site Administrator");
          }
        } else if (response.code === 36) {
          // Account issue
          this.loginistrue = true;
          this.passistrue = false;
          this.password = "";
          this.userexists = false;
          this.submitStatusCheckEmail = "OK";

          if (response.data) {
            this.showError(this.getrans(response.data));
          } else {
            this.showError("This account does not exist. Please contact Site Administrator");
          }
        } else {
          // Unexpected response format - log details
          console.error('Unexpected SSO Email Verify response format:');
          console.error('Full response:', JSON.stringify(response, null, 2));
          console.error('Code:', response.code, 'Type:', typeof response.code);
          console.error('Msg:', response.msg);
          this.showError("Some error occured. Contact Site Administrator");
          this.loginistrue = true;
          this.passistrue = false;
          this.password = "";
          this.userexists = false;
          this.submitStatusCheckEmail = "OK";
        }
      } catch (error) {
        console.error('Email verification failed:', error);
        console.error('Error details:', error.response?.data || error.message);
        this.showError("Some error occured. Contact Site Administrator");
        this.loginistrue = true;
        this.passistrue = false;
        this.password = "";
        this.userexists = false;
        this.submitStatusCheckEmail = "OK";
      }
    },
    cancellogin() {
      this.loginistrue = true;
      this.passistrue = false;
      this.password = "";
      this.userexists = false;
      this.callemailsms = false;
      this.showEmailFallback = false;
      this.emailFallbackTimer = 0;
    },

    startEmailFallbackTimer() {
      if (this.brand_slug === 'LAX') {
        setTimeout(() => {
          this.showEmailFallback = true;
        }, 30000);
      }
    },

    sendEmailFallback() {
      this.submitSendcodeoption_email = true;
      this.emailFallbackTimer = 30;
      
      const timer = setInterval(() => {
        this.emailFallbackTimer--;
        if (this.emailFallbackTimer <= 0) {
          clearInterval(timer);
        }
      }, 1000);

      this.sendEmailOTP(this.emailid);
      
      setTimeout(() => {
        this.submitSendcodeoption_email = false;
        this.display_msg = null;
        Swal.fire({
          title: this.getrans("Success"),
          icon: "success",
          text: this.getrans("OTP sent to your email address"),
          confirmButtonText: this.getrans("OK"),
          timer: 3000
        });
      }, 1000);
    },

    genHash(str) {
      var hash = 0,
        i,
        chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
      }
      return hash;
    },

    async proceedtologinuser() {
      if (this.password == "") {
        this.submitStatusCheckPassword = "ERROR";
        this.passwordWrong = true;
        this.passwordCorrect = false;
        return;
      }

      let emailEntered = this.emailid;
      let passwordEntered = this.password;
      this.submitStatusCheckPassword = "PENDING";
      let device_id = this.genHash(emailEntered);
      
      let dataSearch = {};
      if (this.passwordless) {
        dataSearch = {
          brand_id: this.brand_slug,
          login_id: emailEntered,
          otp_code: passwordEntered,
          device_id: device_id,
          language: this.lang.toUpperCase(),
        };
      } else {
        dataSearch = {
          brand_id: this.brand_slug,
          login_id: emailEntered,
          pwd: passwordEntered,
          device_id: device_id,
          language: this.lang.toUpperCase(),
        };
      }
      
      if (this.display_msg) {
        dataSearch.otp_type = 'sms';
      } else {
        dataSearch.otp_type = 'email';
      }

      try {
        const response = await apiProxy.call('sso_auth_login', dataSearch);
        console.log("sso_auth_login_response.code",response.code.toString());
        if (response.code.toString() == "1") {
          let accessToken = response.msg.accessToken;
          let refreshToken = response.msg.refreshToken;
          let userEmail = response.msg.user_det.email;
          
          this.setLocalData("accessToken", accessToken);
          this.setLocalData("refreshToken", refreshToken);
          this.setLocalData("emailEntered", userEmail);
          
          // Update cookie with new authenticated token using secure service
          if (response.newToken) {
            const secureCookieService = await import('../../services/secureCookieService').then(m => m.default);
            secureCookieService.setSessionToken(response.newToken);
            console.log('Updated cookie with authenticated token for user:', userEmail);
          }
          
          let destinationUrl = "/bookings.html";

          // Handle remember device functionality with rem.php
          if (this.rememberDevice) {
            try {
              const secureCookieService = await import('../../services/secureCookieService').then(m => m.default);
              const sessionToken = secureCookieService.getSessionToken();
              
              const response = await axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/rem.php', {
                action: 'remember-device-store',
                brand_id: this.brand_slug,
                email: emailEntered,
                sessionId: sessionToken
              }, {
                withCredentials: true
              });
              
              if (response.data.success && response.data.deviceId) {
                const deviceData = { deviceId: response.data.deviceId };
                const encrypted = window.btoa(JSON.stringify(deviceData));
                const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
                
                const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
                const isHttps = window.location.protocol === 'https:';
                
                let cookieString;
                if (isLocalhost) {
                  cookieString = `remember_device=${encrypted}; expires=${expires}; path=/; samesite=lax`;
                } else if (isHttps) {
                  cookieString = `remember_device=${encrypted}; expires=${expires}; path=/; secure; samesite=strict`;
                } else {
                  cookieString = `remember_device=${encrypted}; expires=${expires}; path=/; samesite=strict`;
                }
                
                document.cookie = cookieString;
                console.log("Device remembered successfully");
              }
            } catch (e) {
              console.error("Error remembering device:", e);
            }
          }

          

                if (this.brand_slug === 'ST1') {
                  this.generateParkingSession(emailEntered).then(() => {
                    destinationUrl = '/subscriptions_legacy.html';
                    this.gotoPage(destinationUrl);
                  }).catch((e) => {
                    console.error('Parking session error:', e);
                    this.gotoPage(destinationUrl);
                  });
                  return;
                }
                else
                {
                  this.gotoPage(destinationUrl);
                }       

        } else if (response.code == "26") {
          this.showError("Some error occured. Contact Site Administrator");
          this.submitStatusCheckPassword = "ERROR";
          this.forgotPasswordOption = true;
        } else {
          this.showError(response.msg);
          this.submitStatusCheckPassword = "ERROR";
          this.forgotPasswordOption = true;
        }
      } catch (error) {
        console.error('Login failed:', error);
        this.showError("Some error occured. Contact Site Administrator");
        this.passwordWrong = true;
        this.passwordCorrect = false;
        this.submitStatusCheckPassword = "ERROR";
      }
    },
    async generateParkingSession(email) {

      let dataSearch = {
          email: email,
          brand_id: this.brand_slug,
          timestamp: Date.now()
        };
      try {
        const response = await apiProxy.call('ST1 Session Bridge', dataSearch);
        console.log('ST1',response);
        console.log('ST1',response.success);
        console.log('ST1',response.session_token);
        if (response && response.success && response.session_token) {
          this.$cookie.setCookie('stone_session_token', response.session_token, {
            expire: 300 * 60
          });
          console.log('Parking session token generated');
        }
                if (response.guid_token) {
                    this.setSecureCookie('guid_token', response.guid_token);
                }
                if (response.access_token) {
                    localStorage.setItem('accessToken', response.access_token);
                }
                if (response.refresh_token) {
                    localStorage.setItem('refreshToken', response.refresh_token);
                }        
      } catch (error) {
        console.error('Failed to generate parking session:', error);
        throw error;
      }
    },
        setSecureCookie(name, value) {
            const isLocalhost = window.location.hostname === 'localhost';
            const cookieOptions = isLocalhost 
                ? `${name}=${value}; path=/; samesite=strict`
                : `${name}=${value}; path=/; secure; samesite=strict`;
            document.cookie = cookieOptions;
        }    ,
    gotoPage(url) {
      window.location.href = url;
    },
    getLocalData(name) {
      return localStorage.getItem(name);
    },
    setLocalData(name, value) {
      if (value != null) localStorage.setItem(name, value);
      else localStorage.removeItem(name);
    },
    async autologin_remember_device() {
      try {
        console.log("Checking for remembered device...");
        
        const cookie = this.getCookie('remember_device');
        let deviceId = null;
        
        if (cookie) {
          try {
            const decoded = window.atob(cookie);
            const deviceData = JSON.parse(decoded);
            deviceId = deviceData.deviceId;
            console.log('Device ID from cookie:', deviceId);
          } catch (e) {
            console.log('Cookie decode error:', e);
          }
        } else {
          console.log('No remember_device cookie found');
        }
        
        const response = await axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/rem.php', {
          action: 'remember-device-check',
          brand_id: this.brand_slug,
          deviceId: deviceId
        }, {
          withCredentials: true
        });
        
        if (response.data.remembered) {
          console.log("Device remembered, proceeding with auto-login...");
          
          Swal.fire({
            title: "Info",
            text: "Logging in please wait...",
            showConfirmButton: false,
            showCloseButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
          });
          
          this.remember_device_autologin(deviceId);
        }
      } catch (e) {
        console.log("Remember device error:", e);
        Swal.close();
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    },
    
    async remember_device_autologin(deviceId) {
      try {
        const response = await axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/rem.php', {
          action: 'remember-device-login',
          brand_id: this.brand_slug,
          deviceId: deviceId
        }, {
          withCredentials: true
        });
        
        if (response.data.success && response.data.userdata) {
          this.setLocalData("accessToken", response.data.accessToken);
          this.setLocalData("refreshToken", response.data.refreshToken);
          this.setLocalData("emailEntered", response.data.userdata.email);
          
          // Use sessionId from rem.php as the session token (contains UUID)
          if (response.data.sessionId) {
            const secureCookieService = await import('../../services/secureCookieService').then(m => m.default);
            secureCookieService.setSessionToken(response.data.sessionId);
            this.setLocalData("sessionId", response.data.sessionId);
            console.log('Updated session with authenticated token for remember user:', response.data.userdata.email);
          }
          
          this.gotoPage("/bookings.html");
        }
        Swal.close();
      } catch (error) {
        console.log(error);
        Swal.close();
      }
    },
    
    async remember_log(userId) {
      try {
        const response = await axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/rem.php', {
          action: 'remember-device-login',
          brand_id: this.brand_slug,
          userId: userId
        }, {
          withCredentials: true
        });
        
        if (response.data.success && response.data.userdata) {
          this.setLocalData("accessToken", response.data.accessToken);
          this.setLocalData("refreshToken", response.data.refreshToken);
          this.setLocalData("emailEntered", response.data.userdata.email);
          
          // Use sessionId from rem.php as the session token (contains UUID)
          if (response.data.sessionId) {
            const secureCookieService = await import('../../services/secureCookieService').then(m => m.default);
            secureCookieService.setSessionToken(response.data.sessionId);
            this.setLocalData("sessionId", response.data.sessionId);
            console.log('Updated session with authenticated token for remember user:', response.data.userdata.email);
          }
          
          this.gotoPage("/bookings.html");
        }
        Swal.close();
      } catch (error) {
        console.log(error);
        Swal.close();
      }
    },
    async get_rez_data_k() {
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.get("log_key")) {
        Swal.fire({
          title: "Info",
          icon: "info",
          text: "Logging in please wait...",
          showConfirmButton: false,
          showCloseButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        });
      }

      // Initialize brand and language
      this.brand_slug = this.getSlug();
      this.lang = "EN";
      
      // Store brand slug for API mapping
      if (this.brand_slug) {
        sessionStorage.setItem('brandSlug', this.brand_slug);
      }

      if (this.brand_slug === "") {
        const response = await this.setSlug();
        console.log(this.getCurrency());
        const brandingResponse = await this.setBranding(response);
        this.brand_slug = this.getSlug();
        this.branding_data = brandingResponse;
        
        // Store brand slug for API mapping
        sessionStorage.setItem('brandSlug', this.brand_slug);
        await this.loadTranslations();
        
        // Generate token after pre-auth calls are complete
        await this.generateSessionToken();
        
        this.setStyles(this.branding_data.brand_product_styles);
        console.log("bb", this.branding_data);
        this.setMenu(this.branding_data);
        if (urlParams.has("log_key")) {
          this.dew_log(urlParams.get("log_key"));
        }
        if (this.brand_slug == 'LAX') {
          this.autologin_remember_device();
        }
        this.$proxyCheck();
      } else {
        this.branding_data = this.getBranding();
        if (JSON.stringify(this.branding_data) === JSON.stringify({})) {
          const response = await this.setBranding(this.brand_slug);
          this.branding_data = response;
          
          // Store brand slug for API mapping
          sessionStorage.setItem('brandSlug', this.brand_slug);
          await this.loadTranslations();
          
          // Generate token after pre-auth calls are complete
          await this.generateSessionToken();
          
          console.log("dd", this.branding_data);
          this.setStyles(this.branding_data.brand_product_styles);
          this.setMenu(this.branding_data);
          if (urlParams.has("log_key")) {
            this.dew_log(urlParams.get("log_key"));
          }
          if (this.brand_slug == 'LAX') {
            this.autologin_remember_device();
          }
          this.$proxyCheck();
        } else {
          // Generate token even when branding data exists
          await this.generateSessionToken();
          
          console.log("cc", this.branding_data);
          this.loadTranslations();
          this.setStyles(this.branding_data.brand_product_styles);
          this.setMenu(this.branding_data);
          if (urlParams.has("log_key")) {
            this.dew_log(urlParams.get("log_key"));
          }
          if (this.brand_slug == 'LAX') {
            this.autologin_remember_device();
          }
          this.$proxyCheck();
        }
      }
    },
    async dew_log(log_key) {
      if (!log_key || typeof log_key !== "string" || log_key.length > 100) {
        console.error("Invalid log key");
        return Swal.close();
      }

      try {
        const response = await apiProxy.call('activity_log_dew_fortified', {
          brand_id: this.brand_slug.toLowerCase(),
          transaction_token: log_key,
          timestamp: Date.now(), 
        });

        if (!response || !response.data) {
          console.error("Invalid response from server"); 
          return Swal.close();
        }

        if (response.user_exists == "Y" && response.data) {
          let userEmail = response.data;
          
          // For dew login, generate tokens and use newToken from server
          const accessToken = sessionService.generateSecureToken();
          const refreshToken = sessionService.generateSecureToken();
          
          this.setLocalData("accessToken", accessToken);
          this.setLocalData("refreshToken", refreshToken);
          this.setLocalData("emailEntered", userEmail);
          this.setLocalData("lastLogin", Date.now());

          // Use newToken from dew.php (contains UUID) for secure cookie
          if (response.newToken) {
            const secureCookieService = await import('../../services/secureCookieService').then(m => m.default);
            secureCookieService.setSessionToken(response.newToken);
            console.log('Updated cookie with authenticated token for dew user:', userEmail);
          }

          this.gotoPage("/bookings.html");

        } else {
          console.error("Authentication failed");
          Swal.close();
        }
      } catch (error) {
        console.error("Authentication error:", error);
        Swal.close();
      }
    },
    async generateSessionToken() {
      try {
        const token = await sessionService.generateToken(this.brand_slug);
        // Token automatically stored as secure cookie by sessionService
        console.log('Session token generated for brand:', this.brand_slug);
      } catch (error) {
        console.error('Failed to generate session token:', error);
      }
    },
    async generateAuthenticatedSessionToken(userEmail) {
      try {
        const token = await sessionService.generateToken(this.brand_slug, userEmail);
        // Token automatically stored as secure cookie by sessionService
        console.log('Authenticated session token generated for user:', userEmail);
      } catch (error) {
        console.error('Failed to generate authenticated session token:', error);
      }
    },
    showError(message) {
      Swal.fire({
        title: "Alert",
        icon: "error",
        text: message,
        confirmButtonText: "Close",
        showCloseButton: true,
      });
    },
    
    onLogoLoaded() {
      this.logoLoaded = true;
    },
  },
  async mounted() {
    if (
      !sessionStorage.getItem("emailEntered") &&
      !sessionStorage.getItem("userId")
    ) {
      sessionStorage.clear();
    }
    
    this.get_rez_data_k();
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/calenderOverride.scss";
@import "@/assets/sass/swalOverride.scss";
</style>

<style scoped lang="scss">
@import "@/assets/sass/baseTimerModel.scss";
@import "@/assets/sass/formStyles.scss";

$comfirm-button: #ea3e76;

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.top-panel {
  background: var(--header_banner_background, #1a2a40);
  color: var(--header_banner_textcolor, #fff);
  .top-panel-inner {
    max-width: 1270px;
    text-align: left;
    margin: 0 auto;
    padding: 1rem;
    h1 {
      font-weight: lighter;
    }
  }
}

$basketWidth: "420px";
.page-container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  height: auto;
  position: relative;

  .page-time-notice {
    text-align: left;
    display: flex;
    padding: 10px 0;
    p {
      max-width: calc(100% - 120px);
      padding-right: 30px;
      line-height: 1.4;
      font-size: 18px;
    }
    .base-timer-wrapper {
      width: 90px;
      height: 90px;
      margin-top: 15px;
    }
  }

  .big-bold {
    font-size: 20px;
    font-weight: bold;
  }

  .page-left {
    margin: 0 15px;
    margin-bottom: 40px;
    @media screen and (min-width: 958px) {
      width: calc((100% - #{$basketWidth}) - 45px);
      margin-left: 15px;
      margin-right: 30px;
    }
  }
  .page-right {
    width: 0px;
    @media screen and (min-width: 958px) {
      display: block;
      width: #{$basketWidth};
      margin-right: 8px;
    }
  }
}

.confirm-button {
  margin-top: 30px;
  max-width: 480px;
  button {
    min-height: 70px;
    width: 100%;
    height: 100%;
    background: $comfirm-button;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    border: 0px solid #fff;
    border-radius: 3px;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    &:hover {
      background: darken($comfirm-button, 10%);
    }
  }
}

.title-area {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 10px 30px 10px 10px;
  box-sizing: border-box;
  * {
    margin: 0 !important;
    padding: 0 !important;
    @media screen and (max-width: 500px) {
      display: block;
      text-align: left;
      float: none !important;
      margin-top: 16px !important;
    }
  }
  @media screen and (max-width: 959px) {
    display: block;
    width: 100%;
    height: auto;
    padding: 10px;
  }
  @media screen and (max-width: 959px) {
    padding: 10px 0px;
  }
}

.title-area,
.permissions {
  h3 {
    color: #364d5b;
  }
}

.find-address-btn {
  padding: 0;
  height: 48px;
  margin-top: 10px;
  button {
    width: 100%;
    height: 100%;
    background: #006ab3;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    border: 0px solid #fff;
    border-radius: 3px;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    &:hover {
      background: darken(#005b9a, 10%);
    }
  }
}

.postcode-message {
  padding: 20px 10px;
  color: #666666;
  line-height: 1.4;
}

.block-wrap-addresses {
  max-height: 300px;
  overflow-y: scroll;
  overflow-y: auto;
  margin-bottom: 40px;
  display: block;
  div {
    padding: 5px 10px;
  }
}

.p-inputtext.p-component {
  height: 57px;
}

.adult_child_fields {
  border: 1px solid #ddd;
  padding: 0 15px;
  margin-bottom: 30px;
}

.dob-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999999999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.cal-wrapper {
  padding-top: 25px;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 3px;
  position: relative;
  .close-cal-btn {
    font-size: 18px;
    position: absolute;
    right: 0px;
    top: 0px;
    padding: 10px;
    cursor: pointer;
    z-index: 9999;
  }
}

.model-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999999999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .model-inner {
    margin: 10px;
    padding-top: 25px;
    background: #fff;
    border: 1px solid #ced4da;
    border-radius: 3px;
    position: relative;
    .close-model-btn {
      font-size: 18px;
      position: absolute;
      right: 0px;
      top: 0px;
      padding: 10px;
      cursor: pointer;
      z-index: 9999;
    }
    .model-content {
      padding: 15px;
      p {
        color: #666666;
        line-height: 1.4;
      }
      .block {
        width: 100%;
        padding-right: 0px;
      }
      .model-content-btn {
        margin: 0 0 15px;
        width: 100% !important;
      }
    }
  }
}

.forgot-inner {
  max-width: 400px;
}

.adults-fields {
  width: calc(100% / 3);
  @media screen and (max-width: 1280px) {
    width: calc(100% / 2);
  }
}

.child-fields {
  width: calc(100% / 4);
  @media screen and (max-width: 1280px) {
    width: calc(100% / 2);
  }
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

.block-wrap-btn button {
  font-weight: bold;
}

.proceed-btn {
  background: var(--mmb_login_button_background, #0a3b74);
  color: var(--mmb_login_button_font_color, #fff);
  font-size: var(--mmb_login_button_font_size, inherit);
  font-family: var(--mmb_login_button_font_family, inherit);
  font-weight: var(--mmb_login_button_font_weight, inherit);
  border: var(--mmb_login_button_border, none);
  border-radius: var(--mmb_login_button_border_radius, 0);
}

.disabled-link {
  color: #999 !important;
  cursor: not-allowed !important;
  text-decoration: none !important;
}

.block input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.proceed-btn:disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}
</style>

<style>
.internal.internal.internal {
  display: none;
}
</style>